import { Groupe } from "@repo/types";
import { useState } from "react";
import { FormField } from "../../../components/ui/form";
import { useGroupes } from "../../../hooks/api/groupe";
import { useDebounce } from "../../../hooks/use-debounce";
import { EntitySelector } from "./entity-selector";

interface GroupSelectorProps {
  control: any;
  name: string;
  fieldError?: string;
}

export function GroupSelector({ control, name, fieldError }: GroupSelectorProps) {
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  const { data: groupesData, isLoading } = useGroupes({
    page: 1,
    limit: 100,
    search: debouncedSearchTerm,
    sortBy: "recent",
    is_stripped: 'all'
  });

  const handleSearch = (term: string) => {
    setSearchTerm(term);
  };

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <EntitySelector<Groupe>
          name="groupe"
          label="Groupe"
          placeholder="Rechercher un groupe..."
          data={groupesData?.data || []}
          isLoading={isLoading}
          value={field.value}
          onChange={field.onChange}
          hasError={!!fieldError}
          errorMessage={fieldError}
          getItemId={(groupe) => groupe.id}
          getItemName={(groupe) => groupe.name || ''}
          renderLabel={(groupe) => (
            <span>{groupe.name || 'Sans nom'}</span>
          )}
          renderSubLabel={(groupe) => (
            groupe.name_societe ? (
              <span className="text-xs text-gray-500 mt-1">{groupe.name_societe}</span>
            ) : null
          )}
          onSearch={handleSearch}
          searchTerm={searchTerm}
          serverSideSearch={true}
          totalItems={groupesData?.meta.totalPages || 0}
        />
      )}
    />
  );
}
